import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { JSX, ReactNode } from "react";
import styles from "./modal.module.css";
import { IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface CustomModalProps {
  opened: boolean;
  setOpened: (value: boolean) => void;
  title: ReactNode;
  content: JSX.Element;
  width?: number | string;
  headerActions?: ReactNode;
};

export default function CustomModal({
  opened,
  setOpened,
  title,
  content,
  width,
  headerActions,
}: CustomModalProps) {
  return (
    <div
      onClick={(event) => {
        // Modal content is rendered via a portal, but React still bubbles
        // synthetic events up through the JSX tree. Without this, clicking
        // anywhere in the modal (including the backdrop or close button)
        // also triggers onClick handlers on whatever element this modal
        // happens to be nested inside (e.g. a clickable table row).
        event.stopPropagation();
      }}
    >
      <Modal
        open={opened}
        onClose={() => {
          setOpened(false);
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={opened}>
          <Box className={styles.modalContainer} sx={{ width: width || "auto" }}>
            <Box className={styles.modalTitle}>
              <Typography variant="h6" color="inherit" className={styles.modalTitleText}>
                {title}
              </Typography>
              <Box className={styles.modalTitleActions}>
                {headerActions}
                <IconButton onClick={() => setOpened(false)} color="inherit">
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
            <Box className={styles.modalContent}>
              {content}
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
